import {
	FETCH_KB_HUB_FAILURE,
	type FetchKbHubFailureAction,
} from '../../actions/fetch-knowledge-hub-failure';
import {
	FETCH_KB_HUB_SUCCESS,
	type FetchKbHubSuccessAction,
} from '../../actions/fetch-knowledge-hub-success';
import { SET_KB_HUB, type SetKbHubAction } from '../../actions/set-knowledge-hub';
import type { HubState } from './types';
import { removeTrailingSlash } from './utils/string';

type Action = FetchKbHubSuccessAction | FetchKbHubFailureAction | SetKbHubAction;

export const defaultState: HubState = {
	linkedState: 'loading',
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: HubState = defaultState, action: Action): HubState => {
	switch (action.type) {
		case FETCH_KB_HUB_SUCCESS: {
			const { projectKey: _, ...data } = action.payload;
			return {
				id: data.id,
				confluenceUrl: removeTrailingSlash(data.baseUrl),
				spaceKey: data.spaceKey,
				linkedState: 'linked',
			};
		}

		case FETCH_KB_HUB_FAILURE: {
			if (action.payload.error.key === 'sd.kb.link.error.link.not.found') {
				// Confluence was either not linked, or no space was linked yet.
				return {
					linkedState: 'unlinked',
				};
			}

			return {
				messageKey: action.payload.error.key,
				linkedState: 'error',
			};
		}

		case SET_KB_HUB: {
			return action.payload;
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
